// Navbar location control (marketplace pages).
//
// Progressive enhancement over the native <select data-imek-navbar-city>: we
// keep that select (hidden) as the source of truth + a11y fallback, and layer a
// nicer pin-button + filterable popover on top. The chosen city is persisted to
// localStorage under `imek_mkt_city` — the SAME key marketplace_public.js reads
// for dealer proximity — so a pick here follows the buyer through the
// catalogue, dealer lists and cart. No-ops where the select isn't rendered
// (e.g. the webshop).
(function () {
	"use strict";

	var CITY_KEY = "imek_mkt_city";

	function readSaved() {
		try {
			return localStorage.getItem(CITY_KEY) || "";
		} catch (e) {
			return "";
		}
	}

	function writeSaved(value) {
		try {
			localStorage.setItem(CITY_KEY, value || "");
		} catch (e) {
			/* private mode */
		}
	}

	function labelFor(select) {
		var opt = select.options[select.selectedIndex];
		return (opt && opt.value) ? opt.textContent : (select.options[0] ? select.options[0].textContent : "All India");
	}

	function buildControl(select) {
		var wrap = document.createElement("div");
		wrap.className = "imek-city";
		wrap.setAttribute("data-imek-city", "");

		var btn = document.createElement("button");
		btn.type = "button";
		btn.className = "imek-city-btn";
		btn.setAttribute("aria-haspopup", "listbox");
		btn.setAttribute("aria-expanded", "false");
		btn.innerHTML =
			'<svg class="imek-city-pin" viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" ' +
			'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
			'<path d="M12 21s-6-5.2-6-10a6 6 0 0 1 12 0c0 4.8-6 10-6 10z"/><circle cx="12" cy="11" r="2.2"/></svg>' +
			'<span class="imek-city-label"></span>' +
			'<svg class="imek-city-caret" viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" ' +
			'stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><polyline points="6 9 12 15 18 9"/></svg>';

		var pop = document.createElement("div");
		pop.className = "imek-city-pop hidden";
		pop.setAttribute("role", "listbox");

		var filter = document.createElement("input");
		filter.type = "text";
		filter.className = "imek-city-filter";
		filter.setAttribute("placeholder", (window.__ ? window.__("Search location…") : "Search location…"));
		filter.setAttribute("aria-label", filter.getAttribute("placeholder"));

		var list = document.createElement("div");
		list.className = "imek-city-list";

		Array.prototype.forEach.call(select.options, function (opt) {
			var o = document.createElement("button");
			o.type = "button";
			o.className = "imek-city-opt";
			o.setAttribute("data-value", opt.value);
			o.setAttribute("role", "option");
			o.textContent = opt.textContent;
			list.appendChild(o);
		});

		pop.appendChild(filter);
		pop.appendChild(list);
		wrap.appendChild(btn);
		wrap.appendChild(pop);

		return { wrap: wrap, btn: btn, pop: pop, filter: filter, list: list };
	}

	function initCity() {
		var select = document.querySelector("[data-imek-navbar-city]");
		if (!select || select.dataset.imekCityBound) return;
		select.dataset.imekCityBound = "1";

		// Restore a previously chosen city (reset if it is no longer served).
		var saved = readSaved();
		if (saved) {
			select.value = saved;
			if (select.value !== saved) {
				select.value = "";
				writeSaved("");
			}
		}
		select.addEventListener("change", function () {
			writeSaved(select.value || "");
			sync();
		});

		var ui = buildControl(select);
		select.classList.add("imek-city-native");
		select.parentNode.insertBefore(ui.wrap, select);

		function sync() {
			ui.btn.querySelector(".imek-city-label").textContent = labelFor(select);
			var val = select.value || "";
			Array.prototype.forEach.call(ui.list.querySelectorAll(".imek-city-opt"), function (o) {
				o.classList.toggle("is-selected", (o.getAttribute("data-value") || "") === val);
			});
		}

		function open() {
			ui.pop.classList.remove("hidden");
			ui.btn.setAttribute("aria-expanded", "true");
			ui.filter.value = "";
			applyFilter("");
			setTimeout(function () {
				ui.filter.focus();
			}, 0);
		}

		function close() {
			ui.pop.classList.add("hidden");
			ui.btn.setAttribute("aria-expanded", "false");
		}

		function applyFilter(q) {
			q = (q || "").trim().toLowerCase();
			Array.prototype.forEach.call(ui.list.querySelectorAll(".imek-city-opt"), function (o) {
				var hit = !q || o.textContent.toLowerCase().indexOf(q) !== -1;
				o.style.display = hit ? "" : "none";
			});
		}

		ui.btn.addEventListener("click", function (e) {
			e.stopPropagation();
			if (ui.pop.classList.contains("hidden")) open();
			else close();
		});

		ui.filter.addEventListener("input", function () {
			applyFilter(ui.filter.value);
		});
		ui.filter.addEventListener("keydown", function (e) {
			if (e.key === "Escape") {
				close();
				ui.btn.focus();
			}
		});

		ui.list.addEventListener("click", function (e) {
			var opt = e.target.closest(".imek-city-opt");
			if (!opt) return;
			select.value = opt.getAttribute("data-value") || "";
			// fire change so persistence + any listeners run
			select.dispatchEvent(new Event("change", { bubbles: true }));
			close();
			ui.btn.focus();
		});

		document.addEventListener("click", function (e) {
			if (!ui.wrap.contains(e.target)) close();
		});

		sync();
	}

	// Clear (×) inside the search pill. Hidden while the field is empty so the
	// bar stays uncluttered; clearing returns focus to the field and fires an
	// `input` event so the suggestions panel (product_ui/search.js) tears itself
	// down instead of hanging around over an empty query.
	function initClear() {
		var input = document.getElementById("search-box");
		var clear = document.querySelector("[data-imek-search-clear]");
		if (!input || !clear) {
			return;
		}

		function sync() {
			clear.hidden = !input.value;
		}

		input.addEventListener("input", sync);
		clear.addEventListener("click", function () {
			input.value = "";
			input.dispatchEvent(new Event("input", { bubbles: true }));
			input.focus();
			sync();
		});

		sync();
	}

	function init() {
		initCity();
		initClear();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", init);
	} else {
		init();
	}
})();
